module.exports = __webpack_public_path__ + "static/media/teligentiplogo.a334b112.svg";